import React, { useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { cardSlides } from '../data/content';
export function CardCarousel() {
  const trackRef = useRef<HTMLUListElement>(null);
  const [active, setActive] = useState(0);
  const reduceMotion = useReducedMotion();
  const scrollToIndex = (index: number) => {
    const track = trackRef.current;
    const item = track?.children[index] as HTMLElement | undefined;
    if (!track || !item) return;
    track.scrollTo({
      left: item.offsetLeft - track.offsetLeft - 20,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });
  };
  const handleScroll = () => {
    const track = trackRef.current;
    if (!track) return;
    if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
      setActive(cardSlides.length - 1);
      return;
    }
    const items = Array.from(track.children) as HTMLElement[];
    let closest = 0;
    let min = Infinity;
    items.forEach((item, index) => {
      const distance = Math.abs(item.offsetLeft - track.offsetLeft - 20 - track.scrollLeft);
      if (distance < min) {
        min = distance;
        closest = index;
      }
    });
    setActive(closest);
  };
  const go = (step: number) => {
    const next = Math.min(Math.max(active + step, 0), cardSlides.length - 1);
    scrollToIndex(next);
  };
  const arrowClass = 'hidden h-11 w-11 items-center justify-center rounded-full border border-ink/20 bg-white text-ink transition-[background-color,opacity] duration-150 ease-out hover:bg-parchment-deep focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink disabled:opacity-35 sm:flex';
  return <div role="group" aria-roledescription="carrusel" aria-label="Tarjetas del Botiquín Espiritual" data-id="element-44" data-mp="2bcouludrk4af">
      <ul ref={trackRef} onScroll={handleScroll} className="no-scrollbar flex snap-x snap-mandatory gap-4 overflow-x-auto scroll-px-5 px-5 pb-6 pt-2 sm:gap-6" data-id="element-45" data-mp="1wf670vctnx4k">
        {cardSlides.map((slide, index) => <li key={slide.image} className="w-[62%] flex-none snap-start sm:w-[38%] md:w-[30%] lg:w-[22%]" aria-label={`Tarjeta ${index + 1} de ${cardSlides.length}`} data-id="element-46" data-mp="1iaxdjav3djoj" data-mpi={index}>
            <img src={slide.image} alt={`Tarjeta bíblica de ${slide.reference}`} loading="lazy" className="aspect-[2/3] h-auto w-full object-contain drop-shadow-[0_14px_20px_rgba(22,39,63,0.18)]" data-id="element-47" data-mp="13kgh65xbdjyi" />
          </li>)}
      </ul>

      <div className="mt-2 flex items-center justify-center gap-5 px-5" data-id="element-48" data-mp="1r9iw360kcypb">
        <button type="button" onClick={() => go(-1)} disabled={active === 0} aria-label="Tarjeta anterior" className={arrowClass} data-id="element-49" data-mp="1rbluadbvdy54">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-50" data-mp="fsj5qfxs0txx" />
        </button>

        <div className="flex items-center gap-2" data-id="element-51" data-mp="au7uc0ru2bdl">
          {cardSlides.map((slide, index) => <button key={slide.image} type="button" onClick={() => scrollToIndex(index)} aria-label={`Ver la tarjeta de ${slide.reference}`} aria-current={index === active} className={`h-2.5 rounded-full transition-[width,background-color] duration-150 ease-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink ${index === active ? 'w-7 bg-gold-deep' : 'w-2.5 bg-ink/20'}`} data-id="element-52" data-mp="2mkpgio4p3lef" data-mpi={index} />)}
        </div>

        <button type="button" onClick={() => go(1)} disabled={active === cardSlides.length - 1} aria-label="Tarjeta siguiente" className={arrowClass} data-id="element-53" data-mp="3f8v037k0j4co">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-54" data-mp="1kv3klrf05q9b" />
        </button>
      </div>
    </div>;
}